"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const axios_1 = __importDefault(require("axios"));
const ManagementPractice_1 = __importDefault(require("../models/ManagementPractice"));
class ManagementPracticesService {
    constructor() {
        // ********* __FAKE__ ********
        this.management_practices_fake = [
            new ManagementPractice_1.default({ id: 1, name: 'intensive' }),
            new ManagementPractice_1.default({ id: 2, name: 'conventional' }),
            new ManagementPractice_1.default({ id: 3, name: 'wild' }),
            new ManagementPractice_1.default({ id: 4, name: 'organic' }),
            new ManagementPractice_1.default({ id: 5, name: 'biological' }),
            new ManagementPractice_1.default({ id: 6, name: 'regenerative' }),
            new ManagementPractice_1.default({ id: 8, name: 'integrated' }),
            new ManagementPractice_1.default({ id: 9, name: 'ecological' }),
        ];
        this.data = [];
    }
    async fetchManagementPractices() {
        try {
            const response = await axios_1.default.get('/management-practices');
            response.data.forEach((practice) => {
                const cropModel = new ManagementPractice_1.default({ id: practice.id, name: practice.name });
                this.data.push(cropModel);
            });
        }
        catch (error) {
            console.error('Upload failed:', error);
        }
    }
}
exports.default = ManagementPracticesService;
